import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';
import { deleteGetters } from '@/store/extensions/delete';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  ...deleteGetters,

  getDefaultCategory: (state, getters) => type => (
    getters.query()
      .where('type', type)
      .where('default', true)
      .first()
  ),

};



// WEBPACK FOOTER //
// ./src/store/modules/category/getters.js